module.exports = __webpack_public_path__ + "img/currency6.370ce192.png";